import { useCallback, useRef } from 'react'

const useDragAndDropPaths = ({ paths, onDragOver, onDragEnd }) => {
  const dragItem = useRef(null)
  const dragOverItem = useRef(null)

  const handleDragStart = useCallback((index) => {
    dragItem.current = index
  }, [])

  const handleDragEnter = useCallback(
    (index) => {
      // Don't replace the item with itself
      if (index === dragItem.current) return

      dragOverItem.current = index

      const newPaths = [...paths]
      const draggedItemContent = newPaths.splice(dragItem.current, 1)[0]
      newPaths.splice(dragOverItem.current, 0, draggedItemContent)

      dragItem.current = dragOverItem.current

      onDragOver(newPaths)
    },
    [paths, onDragOver]
  )

  const handleDragEnd = useCallback(() => {
    dragItem.current = null
    dragOverItem.current = null
    onDragEnd()
  }, [onDragEnd])

  return {
    handleDragStart,
    handleDragEnter,
    handleDragEnd,
  }
}

export default useDragAndDropPaths
